var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPausedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.561,
    height: 15.536,
    viewBox: "0 0 14.561 15.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pausedIcon",
    transform: "translate(-102.1 20.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14894",
    "data-name": "Group 14894",
    transform: "translate(102.6 -19.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11374",
    "data-name": "Path 11374",
    d: "M112.286-18.2a6.779,6.779,0,0,1,3.875,6.11,6.805,6.805,0,0,1-6.781,6.781A6.805,6.805,0,0,1,102.6-12.09a6.7,6.7,0,0,1,3.875-6.11",
    transform: "translate(-102.6 19.318)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_750",
    "data-name": "Line 750",
    y2: 5.29,
    transform: "translate(6.78 -0.528)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausedIcon);
export default __webpack_public_path__ + "static/media/pausedIcon.3b9c10cb9d6e7b244ae713ec86730050.svg";
export { ForwardRef as ReactComponent };